import { TSearchTypes } from '../interfaces/news';

export const SEARCH_LIST_LIMIT = 10;

export const MAX_SEARCH_INPUT = 100;

export enum SORT_VALUES {
  RELEVANT = 'relevant',
  NEW = 'new',
}

export enum TYPE_VALUES {
  NEWS = 'news',
  QNA = 'qna',
}

export enum FILTERS_NAMES {
  TEXT = 'text',
  TYPE = 'searchType',
  SORT = 'sort',
  PAGE = 'page',
}

export type FILTERS = {
  [FILTERS_NAMES.TEXT]?: string;
  [FILTERS_NAMES.TYPE]?: TSearchTypes;
  [FILTERS_NAMES.SORT]?: SORT_VALUES;
  [FILTERS_NAMES.PAGE]?: number;
};

export const DEFAULT_FILTERS: FILTERS = {
  [FILTERS_NAMES.TYPE]: TYPE_VALUES.NEWS,
  [FILTERS_NAMES.SORT]: SORT_VALUES.RELEVANT,
};

export const SORT_OPTIONS = [
  { label: 'За всё время', value: SORT_VALUES.RELEVANT },
  { label: 'За последний месяц', value: SORT_VALUES.NEW },
];

export const TYPE_OPTIONS = [
  { label: 'Статьи и новости', value: TYPE_VALUES.NEWS },
  { label: 'Вопрос эксперту', value: TYPE_VALUES.QNA },
];
